// A page whose data is fetched on the server with getDataFromTree
// (hoc/with-apollo, hoc/with-data) renders its tree twice there, and since the
// Next 15 upgrade (release 2026-10-24) the server HTML then carries each
// styled-jsx style twice: once in <head> and again in <body>, under the same
// `__jsx-` id. styled-jsx tracks one element per id (the last one in the
// document) and removes only that one when the last component using the style
// unmounts, so the <head> copy outlives the page. For a `global` style that
// copy keeps applying after a client-side navigation: the dashboard's
// FULL_HEIGHT_STYLES and `body { overflow: hidden !important }` left Settings,
// and every page reached from it, unable to scroll.

/**
 * Removes every server-rendered styled-jsx style but the last one per id: the
 * copy styled-jsx tracks, and the one whose rules already win the cascade.
 * Runs before hydration, so styled-jsx never sees the extra copies.
 */
export const dropDuplicateServerStyles = (doc: Document = document) => {
  const styles = Array.from(doc.querySelectorAll('style[id^="__jsx-"]'))
  const lastById = new Map(styles.map(element => [element.id, element]))
  styles.forEach(element => {
    if (lastById.get(element.id) !== element) element.remove()
  })
}
